import { Component, OnInit, Input } from '@angular/core';
import { ItemObject } from 'src/app/models/orders/item/item-object.model';
import { OrderTree } from 'src/app/services/api/orders/orders.service';

@Component({
  selector: 'app-order-map',
  templateUrl: './order-map.component.html',
  styleUrls: ['./order-map.component.scss']
})
export class OrderMapComponent implements OnInit {

  @Input() tree: OrderTree;
  @Input() params: any;
  constructor() {

  }

  ngOnInit() {
  }

}
